import TtamAudienceDmpSelect from './dmp-select/index.vue';
import TtamAudienceEventSelect from './event-select/index.vue';
import TtamAudienceType from './audience-type/index.vue';
import TtamAudienceTypeAlert from './audience-type-alert/index.vue';
import TtamAudienceTypeAlertNew from './audience-type-alert/index-new.vue';
import TtamAudienceAddedViewedSelect from './added-viewed-select/index.vue';
import TtamAudienceCustomActions from './custom-actions/index.vue';
import TtamAudienceInfo from './audience-info/index.vue';
import TtamAntiDiscriminationCheckbox from './anti-discrimination-checkbox/index.vue';

import * as hooks from './hooks';

export default {
  TtamAudienceDmpSelect,
  TtamAudienceEventSelect,
  TtamAudienceType,
  TtamAudienceTypeAlert,
  TtamAudienceTypeAlertNew,
  TtamAudienceAddedViewedSelect,
  TtamAudienceCustomActions,
  TtamAudienceInfo,
  TtamAntiDiscriminationCheckbox,
  ...hooks,
};
